import { render } from "./GridIndex.vue?vue&type=template&id=cb4522c4&ts=true"
import script from "./GridIndex.vue?vue&type=script&lang=ts"
export * from "./GridIndex.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__